// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".used[data-v-26e46e99]{color:#008ca0;font-weight:700}.unused[data-v-26e46e99]{color:#707070}.account-table-component .used[data-v-26e46e99]{color:#008ca0;font-weight:700}.account-table-component .unused[data-v-26e46e99]{color:#707070}.account-table-component .delete-btn[data-v-26e46e99],.account-table-component .edit-btn[data-v-26e46e99]{width:104px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
